var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../../components/UnlinkedApplicationForm";
import { Button, TextField } from "@savvyinsure/react-ui";
import { PHASE } from "../../../../routeConfig";
import { validateDOBFormat, validateDOBYears, validateUnlinkedPolicyHolderData, } from "../../../../features/unlinked-application/validateUnlinkedPolicyHolderData";
import AppBody from "../../../../components/AppBody";
import DateFieldSet from "../../../../components/DateFieldSet";
import Header from "../../../../components/Header";
import { QueryStatus } from "@reduxjs/toolkit/query";
import RouteHeaderLogo from "../../../../components/RouteHeaderLogo";
import { completedPage } from "../../../../lib/Avo";
import dayjs from "dayjs";
import { savePolicyHolder } from "../../../../features/unlinked-application/unlinkedApplicationSlice";
import useAccountReferenceId from "../../../../services/savvy/useAccountReferenceId";
import useAffiliateConfig from "../../../../hooks/useAffiliateConfig";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import useMemoryHistory from "../../../../hooks/useMemoryHistory";
import { usePostAccountReferencePrefillMutation } from "../../../../services/savvy";
import { v4 as uuid } from "uuid";
export default function UnlinkedApplicationPolicyHolderNameAndDob() {
    var _this = this;
    var _a, _b, _c;
    var push = useMemoryHistory().push;
    var _d = useAccountReferenceId(), getAccountReferenceId = _d.getAccountReferenceId, getAccountReferenceStatus = _d.status;
    var _e = usePostAccountReferencePrefillMutation(), postAccountReferencePrefill = _e[0], postPrefillIsLoading = _e[1].isLoading;
    var dispatch = useAppDispatch();
    var affiliateConfig = useAffiliateConfig();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var policyHolder = useAppSelector(function (state) { return state.unlinkedApplication.policyHolder; });
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var isLoading = getAccountReferenceStatus === QueryStatus.pending || postPrefillIsLoading;
    var _f = useForm({
        mode: "all",
        defaultValues: {
            firstName: policyHolder.firstName,
            lastName: policyHolder.lastName,
            dateOfBirth: policyHolder.dateOfBirth,
        },
    }), register = _f.register, _g = _f.formState, errors = _g.errors, isValid = _g.isValid, handleSubmit = _f.handleSubmit, watch = _f.watch, setValue = _f.setValue;
    var firstNameInput = register("firstName", {
        required: "Please enter your first name",
    });
    var lastNameInput = register("lastName", {
        required: "Please enter your last name",
    });
    var dateInput = register("dateOfBirth", {
        required: "Please enter a valid date in the format MM/DD/YYYY",
        validate: {
            isValid: function (value) { return validateDOBFormat(value); },
            isBeforeToday: function (v) {
                return dayjs(v, "MM/DD/YYYY", true).isBefore(dayjs()) ||
                    "Date of birth must be in the past";
            },
            isAtleastEighteen: function (value) {
                return validateDOBYears(value) ||
                    "You must be 18 or older to be the primary policy holder";
            },
        },
    });
    var _h = watch([
        "firstName",
        "lastName",
        "dateOfBirth",
    ]), firstName = _h[0], lastName = _h[1], dateOfBirth = _h[2];
    var submitHandler = handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
        var accountReferenceIdForPrefill, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(savePolicyHolder(data));
                    _a = accountReferenceId;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getAccountReferenceId().unwrap()];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    accountReferenceIdForPrefill = _a;
                    postAccountReferencePrefill({
                        accountReferenceId: accountReferenceIdForPrefill,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        dateOfBirth: dayjs(data.dateOfBirth, ["MM/DD/YYYY"]).format("YYYY-MM-DD") || "",
                        city: policyHolder.city,
                        state: policyHolder.state,
                        zip: policyHolder.zip,
                        address: policyHolder.address1,
                    })
                        .unwrap()
                        .then(function () {
                        push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES);
                    })
                        .catch(function () {
                        // redirect to new vehicle page if unable to prefill
                        push(PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR.replace(":vehicleId", uuid()));
                    })
                        .finally(function () {
                        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Submit", optionSelected: "Submit" }));
                    });
                    return [2 /*return*/];
            }
        });
    }); });
    function handleOnCloseHeader() {
        var policyHolderData = { firstName: firstName, lastName: lastName, dateOfBirth: dateOfBirth };
        var validPolicyHolder = validateUnlinkedPolicyHolderData(policyHolderData);
        if (validPolicyHolder) {
            dispatch(savePolicyHolder(policyHolderData));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true, onClose: handleOnCloseHeader },
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, { as: "form", action: "#", onSubmit: submitHandler },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement("div", { className: "mb-4 flex-none pt-4" },
                    React.createElement(UnlinkedApplicationForm.Header, null, "Tell us about yourself")),
                React.createElement("div", { className: "mb-6 space-y-3 md:space-y-4" },
                    React.createElement(TextField, __assign({ id: "firstName", label: "First Name", "aria-invalid": Boolean(errors.firstName), errorMessage: (_a = errors.firstName) === null || _a === void 0 ? void 0 : _a.message }, firstNameInput)),
                    React.createElement(TextField, __assign({ id: "lastName", label: "Last Name", "aria-invalid": Boolean(errors.lastName), errorMessage: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message }, lastNameInput)),
                    React.createElement(DateFieldSet, { label: "Date of Birth", id: "dateOfBirth", defaultValue: policyHolder.dateOfBirth, name: dateInput.name, onChange: function (value) {
                            setValue("dateOfBirth", value, { shouldValidate: true });
                        }, "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.dateOfBirth), errorMessage: (_c = errors.dateOfBirth) === null || _c === void 0 ? void 0 : _c.message }),
                    React.createElement("div", { className: "" },
                        React.createElement(Button, { disabled: !isValid || isLoading }, isLoading ? "Processing..." : "Continue")),
                    React.createElement("label", { className: "block pb-2 text-xs text-gray-100" },
                        React.createElement("input", { type: "hidden", id: "leadid_tcpa_disclosure" }),
                        React.createElement("p", null,
                            React.createElement("strong", null, "Comparing insurance with Savvy is free and will not affect your credit score."),
                            " ",
                            "By clicking \u201CContinue\u201D you instruct Trellis to provide its information about you to Savvy, and you agree to Savvy's",
                            " ",
                            React.createElement("a", { className: "text-current underline", href: affiliateConfig.privacyPolicyURL, target: "_blank", rel: "noreferrer" }, "Privacy Policy"),
                            ", to Savvy's",
                            " ",
                            React.createElement("a", { className: "text-current underline", href: "https://savvy.insure/terms", target: "_blank", rel: "noreferrer" }, "Terms of Service"),
                            ", and to the use of third-party consumer reports by Savvy's insurers to calculate accurate quotes for you.")))))));
}
